import { j as l } from "./jsx-runtime-DmTjM30f.js";
import { useContext as Q, useState as j, useEffect as $, useRef as he } from "react";
import { F as fe } from "./provider-Diwup2pn.js";
import { S as ie, c as V, a as ue, d as Se, i as ye, M as be, F as Ce, B as ce, b as Le } from "./index.esm-G8KyR0tM.js";
import { r as q } from "./sentry-CAR5o4wv.js";
import { U as Oe, i as N, b as te, k as Fe, E as Ee, D as Ne, F as De, m as Te, V as Me, H as ve, B as Ie, G as Re } from "./utils-D5LKKDAj.js";
import { D as Ae } from "./DetailsCard-DBqpqs8P.js";
import { u as se } from "./useConfiguration-B-lyaBB9.js";
import { i as w } from "./index-wI714H_N.js";
import { AppContext as Ve } from "./AppContext.js";
import { u as Ue } from "./useScrollToBottomRef-CqDzM0dm.js";
import { ErrorPage as le } from "./ErrorPage.js";
const de = ({ isMFSD: O, bankDetails: s, paymentDetails: C }) => {
  const { tenantConfig: D, banks: f } = se(), b = D == null ? void 0 : D.fallbackLogo;
  return (() => {
    var F, U;
    return /* @__PURE__ */ l.jsx(ie, {
      header: {
        title: /* @__PURE__ */ l.jsx("span", {
          className: "neutral-dark-0 font-open-sans text-size-18  inline-block font-semibold",
          children: w._({
            id: "hdSbNW"
          })
        })
      },
      children: /* @__PURE__ */ l.jsxs("div", {
        className: "-mr-2 -ml-2 flex flex-wrap items-center",
        children: [
          O ? /* @__PURE__ */ l.jsx(l.Fragment, {}) : /* @__PURE__ */ l.jsx("div", {
            className: "mb-3 w-full",
            children: /* @__PURE__ */ l.jsx(V, {
              label: w._({
                id: "/dl6Or"
              }),
              value: `${s == null ? void 0 : s.bank_name} (*****${(F = s == null ? void 0 : s.account_number) == null ? void 0 : F.slice(-4)})`,
              logo: f[(U = s == null ? void 0 : s.ifsc) == null ? void 0 : U.slice(0, 4)] || b
            })
          }),
          /* @__PURE__ */ l.jsx("div", {
            className: "mb-3 w-1/2",
            children: /* @__PURE__ */ l.jsx(V, {
              label: w._({
                id: "lFCwug"
              }),
              value: O ? "Salary" : Oe(C == null ? void 0 : C.method)
            })
          })
        ]
      })
    });
  })();
}, Be = ({ transactionId: O, investor: s, isGroupInvestment: C, isPartner: D, handlePayment: f }) => {
  const { fpapi: b } = Q(fe), [H, F] = j({}), [U, J] = j({}), [Z, X] = j({}), [B, h] = j(!1), [S, R] = j({}), [z, v] = j({}), [m, p] = j({}), A = !C && f && !N(S) && (S == null ? void 0 : S.status) === "APPROVED";
  $(() => {
    (async () => {
      h(!0);
      try {
        let d;
        if (O) {
          const I = te(O);
          I === "Purchase" ? d = await b.fpClient.mf_purchases().fetch(O) : I === "Withdraw" ? d = await b.fpClient.mf_redemptions().fetch(O) : d = await b.fpClient.mf_switches().fetch(O), p(d);
        }
        const g = (d == null ? void 0 : d.object) === "mf_switch" ? d == null ? void 0 : d.switch_in_scheme : d == null ? void 0 : d.scheme, c = await b.fpClient.master_data().fetchScheme(g);
        if (J(c), (d == null ? void 0 : d.object) === "mf_switch") {
          const I = await b.fpClient.master_data().fetchScheme(d == null ? void 0 : d.switch_out_scheme);
          X(I);
        }
        h(!1);
      } catch (d) {
        window.debug.error(d), h(!1), q(d);
      }
    })();
  }, []);
  const K = async (d) => {
    h(!0);
    try {
      const g = await b.fpClient.payments().fetchAll({
        amc_order_ids: d
      });
      N(g == null ? void 0 : g.payments[0]) || R(g == null ? void 0 : g.payments[0]), h(!1);
    } catch (g) {
      window.debug.error(g), h(!1), q(g);
    }
  };
  return $(() => {
    (m == null ? void 0 : m.object) === "mf_purchase" && K(m == null ? void 0 : m.old_id);
  }, [
    m
  ]), $(() => {
    (async () => {
      if (s != null && s.id && (m != null && m.id)) {
        if (C) {
          h(!0);
          try {
            const d = await b.fpClient.mf_settlement_details().fetchAll({
              mf_purchase: m == null ? void 0 : m.id
            });
            N(d) || v(d), h(!1);
          } catch (d) {
            window.debug.error(d), h(!1), q(d);
          }
        } else if (!C && !N(S)) {
          h(!0);
          try {
            const d = S, { data: g } = await b.fpClient.bank_accounts().fetchAll({
              profile: s == null ? void 0 : s.id
            }), c = g.find((I) => I.old_id === (d == null ? void 0 : d.from_bank_account_id));
            F({
              bank_name: c == null ? void 0 : c.bank_name,
              account_number: c == null ? void 0 : c.account_number,
              ifsc: c == null ? void 0 : c.ifsc_code
            }), h(!1);
          } catch (d) {
            window.debug.error(d), h(!1), q(d);
          }
        }
      }
    })();
  }, [
    s == null ? void 0 : s.id,
    m == null ? void 0 : m.id,
    S,
    C
  ]), B ? /* @__PURE__ */ l.jsx(ue, {
    variant: "fullpage"
  }) : /* @__PURE__ */ l.jsxs("div", {
    children: [
      N(m) ? /* @__PURE__ */ l.jsx(l.Fragment, {}) : /* @__PURE__ */ l.jsx(Ae, {
        order: m,
        isInstallmentListing: !1,
        handlePayment: f,
        scheme: U,
        switchOutScheme: Z,
        isGroupInvestment: C,
        isPartner: D,
        paymentDetails: S
      }),
      N(z) ? null : /* @__PURE__ */ l.jsx(de, {
        isMFSD: !0
      }),
      A ? /* @__PURE__ */ l.jsx(de, {
        isMFSD: !1,
        bankDetails: H,
        paymentDetails: S
      }) : /* @__PURE__ */ l.jsx(l.Fragment, {})
    ]
  });
};
function Ge({ isGroupInvestment: O, investor: s, mfInvestmentAccount: C, isPartner: D, searchParams: f }) {
  const { fpapi: b } = Q(fe), { amcs: H, tenantConfig: F } = se(), { AppState: { tenant: U } } = Q(Ve), J = F == null ? void 0 : F.fallbackLogo, Z = F == null ? void 0 : F.showSchemeLogo, [X, B] = j("initial"), [h, S] = j(!0), [R, z] = j([]), [v, m] = j([]), [p, A] = j({}), [K, d] = j(!1), g = he(null), [c, I] = j(null), k = Ue(c), [oe, G] = j(!1), [Y, me] = j(10);
  $(() => {
    X === "initial" && P();
  }, [
    X
  ]), $(() => {
    k.hasScrolledToBottom && pe();
  }, [
    k.hasScrolledToBottom
  ]), $(() => {
    var e;
    (e = g == null ? void 0 : g.current) == null || e.scrollIntoView({
      behavior: "instant",
      block: "center",
      inline: "center"
    });
  }, [
    K,
    h
  ]);
  const _e = async (e) => {
    const u = [];
    for (const o of e)
      try {
        const i = await b.fpClient.master_data().fetchScheme(o), t = Z ? {
          ...i,
          schemeLogo: H[i == null ? void 0 : i.amc_id] || J
        } : {
          ...i
        };
        u.push(t);
      } catch (i) {
        window.debug.error(i), q(i);
      }
    return u;
  }, r = (e, u) => u == null ? void 0 : u.filter((i) => {
    let t, L, y;
    return e != null && e.folio_number && i.folio_number !== (e == null ? void 0 : e.folio_number) ? t = !1 : t = !0, e != null && e.isin && (i.scheme !== (e == null ? void 0 : e.isin) || i.plan) ? L = !1 : L = !0, e != null && e.status && (e == null ? void 0 : e.status.split(",").indexOf("failed")) != -1 && i.state === "failed" && i.failure_code !== "payment_failure" ? y = !1 : y = !0, t && L && y;
  }), n = async (e, u, o, i) => {
    const t = structuredClone(i);
    try {
      u = (await b.fpClient.payments().fetchAll({
        amc_order_ids: e.join()
      })).payments;
      let y = [];
      const T = await _e(o);
      return y = structuredClone(T), t.forEach((E) => {
        const _ = y.find((M) => M.isin === E.scheme);
        if (_ && (E.schemeDetails = _), u) {
          const M = u.filter((x) => {
            var W;
            return ((W = x == null ? void 0 : x.amc_order_ids) == null ? void 0 : W[0]) === (E == null ? void 0 : E.old_id);
          });
          E.paymentDetails = M;
        }
      }), t;
    } catch {
      B("error"), S(!1);
    }
  }, pe = async () => {
    if (Y >= v.length)
      return;
    G(!0);
    let e;
    if (C.id, f != null && f.status && f.status, v != null && v.length) {
      let u = v;
      if (f != null && f.folio_number || f != null && f.status || f != null && f.isin) {
        const _ = r(f, u);
        u = structuredClone(_);
      }
      const o = u.sort((_, M) => new Date(M == null ? void 0 : M.created_at).valueOf() - new Date(_ == null ? void 0 : _.created_at).valueOf()), i = Y + 10, t = o == null ? void 0 : o.slice(Y, i), L = structuredClone(t);
      me(i);
      const y = /* @__PURE__ */ new Set(), T = [];
      t.forEach((_) => {
        y.add(_ == null ? void 0 : _.scheme), T.push(_ == null ? void 0 : _.old_id);
      });
      const E = await n(T, e, y, t);
      N(p) ? A(L[0]) : A(p), z((_) => _.concat(E)), G(!1);
    }
  }, P = async () => {
    var i;
    if (N(C)) {
      B("no_listing"), S(!1);
      return;
    }
    S(!0);
    let e, u;
    const o = {
      mf_investment_account: C.id
    };
    f != null && f.status && (o.states = f.status);
    try {
      e = await b.fpClient.mf_purchases().fetchAll(o), m(e == null ? void 0 : e.data);
    } catch (t) {
      window.debug.error(t), B("no_listing"), S(!1), q(t);
      return;
    }
    if ((i = e == null ? void 0 : e.data) != null && i.length) {
      let t = e.data;
      if (f != null && f.folio_number || f != null && f.status || f != null && f.isin) {
        const x = r(f, t);
        t = structuredClone(x);
      }
      const L = t.sort((x, W) => new Date(W == null ? void 0 : W.created_at).valueOf() - new Date(x == null ? void 0 : x.created_at).valueOf()), y = L == null ? void 0 : L.slice(0, Y), T = structuredClone(y), E = /* @__PURE__ */ new Set(), _ = [];
      y.forEach((x) => {
        E.add(x == null ? void 0 : x.scheme), _.push(x == null ? void 0 : x.old_id);
      });
      const M = await n(_, u, E, y);
      N(p) ? A(T[0]) : A(p), z(M);
    } else
      B("no_listing");
    S(!1);
  }, ge = (e) => {
    var T;
    const u = [
      "SUCCESS",
      "INITIATED",
      "APPROVED",
      "SUBMITTED",
      "PENDING"
    ], o = [
      "FAILED",
      "TIMEDOUT"
    ];
    let i = !1, t = !1;
    (T = e == null ? void 0 : e.paymentDetails) != null && T.length && (u.includes(e == null ? void 0 : e.paymentDetails[0].status) && (i = !0), o.includes(e == null ? void 0 : e.paymentDetails[0].status) && (t = !0));
    const L = (e == null ? void 0 : e.state) === "pending" && !i, y = (e == null ? void 0 : e.state) === "failed" && (e == null ? void 0 : e.failure_code) === "payment_failure" && !i && t;
    return {
      isPaymentPending: L,
      isPaymentRetry: y
    };
  }, a = (e, u) => {
    if (D)
      Me(ve(U) + "/payment?order_id=" + e.id);
    else {
      const o = window.location.origin + Ie + "/payment?order_id=" + e.id;
      window.location.href = o;
    }
  }, we = (e) => {
    A(v[e.target.value]);
  }, xe = (e) => {
    var u;
    if (!O && !(e != null && e.plan) && (e == null ? void 0 : e.object) === "mf_purchase") {
      const { isPaymentPending: o, isPaymentRetry: i } = ge(e);
      if (D && (o || i))
        return {
          buttonText: w._({
            id: "WnGhts"
          })
        };
      if (o)
        return {
          buttonText: w._({
            id: "mtFRI7"
          })
        };
      if (i)
        return Re((u = e == null ? void 0 : e.paymentDetails[0]) == null ? void 0 : u.created_at) ? {
          buttonText: w._({
            id: "vgDUPm"
          })
        } : {
          title: /* @__PURE__ */ l.jsx(l.Fragment, {
            children: /* @__PURE__ */ l.jsx("div", {
              className: "text-center",
              children: w._({
                id: "7XOaxV"
              })
            })
          })
        };
    }
  }, ee = () => /* @__PURE__ */ l.jsxs(l.Fragment, {
    children: [
      R.length ? /* @__PURE__ */ l.jsx(Se, {
        variant: "selectable",
        onChange: we,
        selected: (R == null ? void 0 : R.findIndex((e) => e.id === (p == null ? void 0 : p.id))) || 0,
        children: R.map((e) => {
          var u, o, i, t;
          return /* @__PURE__ */ l.jsx(ie, {
            footer: xe(e),
            onClick: () => a(e),
            innerRef: I,
            children: /* @__PURE__ */ l.jsxs("div", {
              className: "flex flex-wrap py-2",
              ref: (e == null ? void 0 : e.id) === (p == null ? void 0 : p.id) ? g : null,
              children: [
                /* @__PURE__ */ l.jsx("div", {
                  className: "mb-3 basis-full",
                  children: /* @__PURE__ */ l.jsx(V, {
                    label: w._({
                      id: "XTJZw8"
                    }),
                    value: N(e == null ? void 0 : e.schemeDetails) ? "-" : Fe((u = e == null ? void 0 : e.schemeDetails) == null ? void 0 : u.name),
                    logo: Z ? H[(o = e == null ? void 0 : e.schemeDetails) == null ? void 0 : o.amc_id] || J : ""
                  })
                }),
                /* @__PURE__ */ l.jsx("div", {
                  className: "mb-3 basis-1/2",
                  children: /* @__PURE__ */ l.jsx(V, {
                    label: w._({
                      id: "KqeLJ1"
                    }),
                    value: e != null && e.amount ? `₹ ${Ee(e == null ? void 0 : e.amount)}` : "-"
                  })
                }),
                /* @__PURE__ */ l.jsx("div", {
                  className: "mb-3 basis-1/2",
                  children: /* @__PURE__ */ l.jsx(V, {
                    label: w._({
                      id: "e7LnWq"
                    }),
                    value: e != null && e.state ? /* @__PURE__ */ l.jsx(ye, {
                      variant: "outline",
                      message: `${(e == null ? void 0 : e.state) === "pending" && ((t = (i = e == null ? void 0 : e.paymentDetails) == null ? void 0 : i[0]) == null ? void 0 : t.status) === "INITIATED" ? "Payment processing" : Ne(e == null ? void 0 : e.state, e == null ? void 0 : e.object, e == null ? void 0 : e.failure_code)}`,
                      status: De(e == null ? void 0 : e.state)
                    }) : "-"
                  })
                }),
                /* @__PURE__ */ l.jsx("div", {
                  className: "mb-3 basis-1/2",
                  children: /* @__PURE__ */ l.jsx(V, {
                    label: w._({
                      id: "ItmT+q"
                    }),
                    value: e != null && e.created_at ? Te(new Date(e == null ? void 0 : e.created_at), "dd-MMM-yyyy") : "-"
                  })
                }),
                /* @__PURE__ */ l.jsx("div", {
                  className: "mb-3 basis-1/2",
                  children: /* @__PURE__ */ l.jsx(V, {
                    label: w._({
                      id: "cXcPd1"
                    }),
                    value: e != null && e.folio_number ? e == null ? void 0 : e.folio_number : "New folio"
                  })
                })
              ]
            })
          }, e == null ? void 0 : e.id);
        })
      }) : /* @__PURE__ */ l.jsx(l.Fragment, {}),
      oe ? /* @__PURE__ */ l.jsx("div", {
        className: "flex justify-center",
        children: /* @__PURE__ */ l.jsx(be, {
          type: "important",
          variant: "field",
          title: "Loading..",
          loader: !0,
          customClass: "mb-5 "
        })
      }) : /* @__PURE__ */ l.jsx(l.Fragment, {}),
      p ? /* @__PURE__ */ l.jsx(Ce, {
        children: /* @__PURE__ */ l.jsx(ce, {
          variant: "primary",
          fullwidth: !0,
          onClick: (e) => {
            e.preventDefault(), d(!0);
          },
          children: w._({
            id: "f9pW3a"
          })
        })
      }) : null,
      /* @__PURE__ */ l.jsx(Le, {
        variant: "fullPage",
        contentHeightMax: !0,
        title: w._({
          id: "cHu8/t",
          values: {
            0: te(p == null ? void 0 : p.id)
          }
        }),
        isOpen: K,
        toggleModal: () => {
          P(), d(!1);
        },
        children: /* @__PURE__ */ l.jsx(Be, {
          transactionId: p == null ? void 0 : p.id,
          isGroupInvestment: O,
          investor: s,
          handlePayment: a,
          isPartner: D
        })
      })
    ]
  });
  function je() {
    switch (X) {
      case "initial":
        return ee();
      case "no_listing":
        return /* @__PURE__ */ l.jsx(le, {
          title: w._({
            id: "b9eV+m"
          }),
          description: w._({
            id: "TYsDi/"
          }),
          showDetails: !1,
          showAction: !1
        });
      case "error":
        return /* @__PURE__ */ l.jsx(le, {
          title: w._({
            id: "w7WdjZ"
          }),
          showDetails: !1,
          showAction: !1
        });
      default:
        return ee();
    }
  }
  return h ? /* @__PURE__ */ l.jsx(ue, {
    variant: "fullpage"
  }) : je();
}
export {
  Be as O,
  Ge as P
};
